import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "aroona",
  name: "Aroona",
  title: "Aroona conveyancing, wills and estates",
  metaTitle: `Aroona Conveyancing & Wills Lawyers | ${FIRM.name}`,
  description: `Fixed-fee Aroona conveyancing — sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. Wills, enduring powers of attorney and deceased estates. Call ${FIRM.phone}.`,
  lead: "Aroona is a quiet, established family suburb backing onto bushland reserve. Most sales are standard freehold houses, which should mean a simple conveyance — provided the searches are actually done and the disclosure is complete.",
  paragraphs: [
    "We act for Aroona buyers and sellers from our Golden Beach office on the same fixed fees we quote everywhere else. On a straightforward house purchase our job is to keep it straightforward: check the contract before you sign, run the searches that matter, and hold the finance and inspection dates in view so nothing lapses.",
    "Established suburbs like Aroona throw up recurring search issues — extensions or sheds built without approval, encroaching fences, easements running along rear boundaries and pool safety certificates that were never obtained.",
    "Aroona also has a strong contingent of long-term owners now planning ahead. Wills, enduring powers of attorney and advance health directives are the three documents we most often prepare together for families here.",
  ],
  localNotes: [
    {
      t: "Boundary and fencing issues",
      d: "Rear fences against reserve land are not always on the true boundary. An identification survey settles it before you own the problem.",
    },
    {
      t: "Unapproved extensions",
      d: "Patios, carports and granny flat conversions need approval. If council has no record, the buyer inherits the liability — we check during the search period.",
    },
    {
      t: "Pool safety certificates",
      d: "A seller must give a certificate or a notice of no matching certificate before settlement. Non-compliant fencing is a common late-stage delay.",
    },
    {
      t: "Planning ahead as a family",
      d: "A will, enduring power of attorney and advance health directive prepared together cost less and work better than three separate exercises.",
    },
  ],
  suburbs: ["Currimundi", "Little Mountain", "Battery Hill", "Meridan Plains", "Caloundra", "Dicky Beach"],
  faqs: [
    {
      q: "What searches do you run on an Aroona house purchase?",
      a: "Title and registered dealings, council rates and planning, water, land tax, transport and state government interests, plus a contaminated land search. We add flood, survey or environmental searches when the property calls for it.",
    },
    {
      q: "How much is conveyancing in Aroona?",
      a: `Our fixed professional fee is ${FEES.sale} including GST to sell and ${FEES.purchase} including GST to buy. Searches, transfer duty and registration fees are additional and itemised up front.`,
    },
    {
      q: "Do I need a new will if I move house?",
      a: "Not always, but you should review it. A will that gifts a named property fails if you no longer own it, and a move often coincides with other changes — a new relationship, grandchildren, or a change of executor.",
    },
  ],
};
